import React from "react";

export const RestoreIcon = ({ className = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    className={className}
    {...props}
  >
    <path
      d="M15.3171 12.1671C14.697 12.9464 13.9728 13.575 13.1447 14.0532C12.3165 14.5313 11.41 14.8441 10.4251 14.9915C9.44021 15.139 8.44275 15.0774 7.43275 14.8068C7.20382 14.7454 7.03267 14.6166 6.9193 14.4202C6.80593 14.2238 6.77991 14.0112 6.84126 13.7823C6.9026 13.5533 7.03145 13.3822 7.22782 13.2688C7.42418 13.1554 7.63683 13.1294 7.86576 13.1908C9.44136 13.6129 10.925 13.4223 12.3166 12.6189C13.7082 11.8154 14.6151 10.6259 15.0373 9.05029C15.4595 7.47469 15.2688 5.99108 14.4654 4.59946C13.6619 3.20784 12.4724 2.30094 10.8968 1.87876C9.3212 1.45658 7.83759 1.64722 6.44598 2.45067C5.05436 3.25412 4.14746 4.44364 3.72528 6.01924L3.6928 6.14044L4.56363 5.63767C4.76853 5.51937 4.97781 5.49246 5.19148 5.55692C5.40514 5.62139 5.57292 5.74934 5.69483 5.94078C5.81313 6.14568 5.84588 6.36013 5.79307 6.58413C5.74027 6.80814 5.61141 6.97929 5.40651 7.09759L2.76842 8.62069C2.56352 8.73899 2.35333 8.76928 2.13787 8.71154C1.9224 8.65381 1.75552 8.52249 1.63722 8.31759L0.114111 5.67949C-0.00418853 5.47459 -0.0302026 5.26194 0.0360691 5.04155C0.102341 4.82115 0.237927 4.65181 0.442828 4.53351C0.64412 4.42867 0.853402 4.40176 1.07067 4.45276C1.28794 4.50376 1.45573 4.63171 1.57403 4.83661L2.0768 5.70744L2.10928 5.58624C2.37991 4.57624 2.82529 3.68162 3.44544 2.9024C4.06559 2.12317 4.78974 1.49449 5.61788 1.01636C6.44602 0.538235 7.35254 0.225446 8.33745 0.0779949C9.32236 -0.0694557 10.3198 -0.00786672 11.3298 0.262762C12.3398 0.533391 13.2344 0.97878 14.0137 1.59893C14.7929 2.21908 15.4216 2.94322 15.8997 3.77136C16.3778 4.5995 16.6906 5.50603 16.8381 6.49093C16.9855 7.47584 16.9239 8.47329 16.6533 9.48329C16.3827 10.4933 15.9373 11.3879 15.3171 12.1671Z"
      fill="black"
      fillOpacity="0.7"
    />
  </svg>
);

export const PlusIcon = ({ className = "", ...props }) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 4v16m8-8H4"
    />
  </svg>
);

export const MinusIcon = ({ className = "", ...props }) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20 12H4"
    />
  </svg>
);
export const ActionIcon = ({ className = "", ...props }) => (
  <svg
  xmlns="http://www.w3.org/2000/svg"
  width="14"
  height="4"
  viewBox="0 0 14 4"
  fill="none"
>
  <path
    d="M1.68254 3.36508C1.21984 3.36508 0.823743 3.20033 0.494246 2.87083C0.164749 2.54134 0 2.14524 0 1.68254C0 1.21984 0.164749 0.823743 0.494246 0.494246C0.823743 0.164749 1.21984 0 1.68254 0C2.14524 0 2.54134 0.164749 2.87083 0.494246C3.20033 0.823743 3.36508 1.21984 3.36508 1.68254C3.36508 2.14524 3.20033 2.54134 2.87083 2.87083C2.54134 3.20033 2.14524 3.36508 1.68254 3.36508ZM6.73016 3.36508C6.26746 3.36508 5.87136 3.20033 5.54187 2.87083C5.21237 2.54134 5.04762 2.14524 5.04762 1.68254C5.04762 1.21984 5.21237 0.823743 5.54187 0.494246C5.87136 0.164749 6.26746 0 6.73016 0C7.19286 0 7.58896 0.164749 7.91845 0.494246C8.24795 0.823743 8.4127 1.21984 8.4127 1.68254C8.4127 2.14524 8.24795 2.54134 7.91845 2.87083C7.58896 3.20033 7.19286 3.36508 6.73016 3.36508ZM11.7778 3.36508C11.3151 3.36508 10.919 3.20033 10.5895 2.87083C10.26 2.54134 10.0952 2.14524 10.0952 1.68254C10.0952 1.21984 10.26 0.823743 10.5895 0.494246C10.919 0.164749 11.3151 0 11.7778 0C12.2405 0 12.6366 0.164749 12.9661 0.494246C13.2956 0.823743 13.4603 1.21984 13.4603 1.68254C13.4603 2.14524 13.2956 2.54134 12.9661 2.87083C12.6366 3.20033 12.2405 3.36508 11.7778 3.36508Z"
    fill="black"
    fill-opacity="0.5"
  />
</svg>
);